"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var themes_1 = require("./themes");

var utils_1 = require("./utils");

exports.Input = styled_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: ", ";\n  width: ", ";\n  display: inline-block;\n  color: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  box-sizing: border-box;\n  font: ", ";\n  ", "\n  ", "\n\n  &:disabled {\n    background: rgba(239, 239, 239, 0.3);\n  }\n"], ["\n  text-align: ", ";\n  width: ", ";\n  display: inline-block;\n  color: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  box-sizing: border-box;\n  font: ", ";\n  ", "\n  ", "\n\n  &:disabled {\n    background: rgba(239, 239, 239, 0.3);\n  }\n"])), function (_a) {
  var align = _a.align;
  return align || 'left';
}, function (_a) {
  var width = _a.width;
  return width || '100%';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.color;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.background, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.background;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.borderColor, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.borderColor;
}, utils_1.getBorderRadius('input'), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingVertical;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingVertical;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.font, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.font;
}, function (_a) {
  var hasPrefix = _a.hasPrefix;
  return !hasPrefix ? '' : "\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  ";
}, function (_a) {
  var _b = _a.hasSuffix,
      hasSuffix = _b === void 0 ? '' : _b;
  return !hasSuffix ? '' : "\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  ";
});
exports.InputContainer = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: ", ";\n  width: ", ";\n  display: inline-flex;\n  color: ", ";\n  background: ", ";\n  box-sizing: border-box;\n  font: ", ";\n"], ["\n  text-align: ", ";\n  width: ", ";\n  display: inline-flex;\n  color: ", ";\n  background: ", ";\n  box-sizing: border-box;\n  font: ", ";\n"])), function (_a) {
  var align = _a.align;
  return align || 'left';
}, function (_a) {
  var width = _a.width;
  return width || '100%';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.color;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.background, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.background;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.font, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.font;
});
exports.InputPrefix = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n  background: rgba(239, 239, 239, 0.5);\n"], ["\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0;\n  background: rgba(239, 239, 239, 0.5);\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.borderColor, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.borderColor;
}, utils_1.getBorderRadius('input'), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingVertical;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingVertical;
});
exports.InputSuffix = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border: 1px solid\n    ", ";\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 0;\n  background: rgba(239, 239, 239, 0.5);\n"], ["\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border: 1px solid\n    ", ";\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  padding-bottom: ", "px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 0;\n  background: rgba(239, 239, 239, 0.5);\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.borderColor, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.borderColor;
}, utils_1.getBorderRadius('card'), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.borderColor, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.borderColor;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingVertical;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.input) === null || _c === void 0 ? void 0 : _c.paddingVertical, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.input.paddingVertical;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;